import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { TodayNotes } from ".";

const initialState: TodayNotes = {
  title: "",
  text: "",
};

const store = proxy<TodayNotes>({ ...initialState });

export const toolkitTodayActions = {
  setNotes(notes: TodayNotes) {
    Object.assign(store, initialState, notes);
  },
};

export function useToolkitTodayStore() {
  return useSnapshot(store);
}

export function getToolkitTodayState() {
  return snapshot(store);
}

export function resetToolkitTodayStore() {
  Object.assign(store, initialState);
}
